import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const OUTREACHES_REQUEST = 'OUTREACHES_REQUEST';
export const OUTREACHES_SUCCESS = 'OUTREACHES_SUCCESS';
export const OUTREACHES_FAILURE = 'OUTREACHES_FAILURE';

export const OUTREACH_DETAIL_REQUEST = 'OUTREACH_DETAIL_REQUEST';
export const OUTREACH_DETAIL_SUCCESS = 'OUTREACH_DETAIL_SUCCESS';
export const OUTREACH_DETAIL_FAILURE = 'OUTREACH_DETAIL_FAILURE';

export const STATES_REQUEST = 'STATES_REQUEST';
export const STATES_SUCCESS = 'STATES_SUCCESS';
export const STATES_FAILURE = 'STATES_FAILURE';

export const OUTREACH_TYPES_REQUEST = 'OUTREACH_TYPES_REQUEST';
export const OUTREACH_TYPES_SUCCESS = 'OUTREACH_TYPES_SUCCESS';
export const OUTREACH_TYPES_FAILURE = 'OUTREACH_TYPES_FAILURE';

export const REFERRAL_CATEGORIES_REQUEST = 'REFERRAL_CATEGORIES_REQUEST';
export const REFERRAL_CATEGORIES_SUCCESS = 'REFERRAL_CATEGORIES_SUCCESS';
export const REFERRAL_CATEGORIES_FAILURE = 'REFERRAL_CATEGORIES_FAILURE';

export const REFERRALDIRECTORY_UPDATE_REQUEST = 'REFERRALDIRECTORY_UPDATE_REQUEST';
export const REFERRALDIRECTORY_UPDATE_SUCCESS = 'REFERRALDIRECTORY_UPDATE_SUCCESS';
export const REFERRALDIRECTORY_UPDATE_FAILURE = 'REFERRALDIRECTORY_UPDATE_FAILURE';

export const REFERRALS_TYPEAHEAD_REQUEST = 'REFERRALS_TYPEAHEAD_REQUEST';
export const REFERRALS_TYPEAHEAD_SUCCESS = 'REFERRALS_TYPEAHEAD_SUCCESS';
export const REFERRALS_TYPEAHEAD_FAILURE = 'REFERRALS_TYPEAHEAD_FAILURE';

export const REFERRALCATEGORY_REQUEST = 'REFERRALCATEGORY_REQUEST';
export const REFERRALCATEGORY_SUCCESS = 'REFERRALCATEGORY_SUCCESS';
export const REFERRALCATEGORY_FAILURE = 'REFERRALCATEGORY_FAILURE';

export const REFERRALCATEGORY_DETAILS_REQUEST = 'REFERRALCATEGORY_DETAILS_REQUEST';
export const REFERRALCATEGORY_DETAILS_SUCCESS = 'REFERRALCATEGORY_DETAILS_SUCCESS';
export const REFERRALCATEGORY_DETAILS_FAILURE = 'REFERRALCATEGORY_DETAILS_FAILURE';

export function requestOutreaches(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/outreach/search?${query}`,
      method: 'GET',
      types: ['OUTREACHES_REQUEST', 'OUTREACHES_SUCCESS', 'OUTREACHES_FAILURE']
    }
  };
}

export function requestOutreachDetails(id, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/outreach/${id}?${query}`,
      method: 'GET',
      types: [
        { type: 'OUTREACH_DETAIL_REQUEST', meta: { id } },
        { type: 'OUTREACH_DETAIL_SUCCESS', meta: { id } },
        { type: 'OUTREACH_DETAIL_FAILURE', meta: { id } },
      ]
    }
  }
}

export function deleteReferral(referralId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/referral/delete/${referralId}?${query}`,
      method: 'DELETE',
      body: JSON.stringify(referralId),
      types: ["REFERRAL_DELETE_REQUEST", "REFERRAL_DELETE_SUCCESS", "REFERRAL_DELETE_FAILURE"]
    }
  }
}

export function updateOutreach(outreach, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/outreach?${query}`,
      method: 'POST',
      body: JSON.stringify(outreach),
      types: ["OUTREACH_UPDATE_REQUEST", "OUTREACH_UPDATE_SUCCESS", "OUTREACH_UPDATE_FAILURE"]
    }
  }
}

export function requestStates(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/states/all?${query}`,
      method: 'GET',
      types: ['STATES_REQUEST', 'STATES_SUCCESS', 'STATES_FAILURE',]
    }
  }
}

export function requestOutreachTypes(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/advocate/outreach/types?${query}`,
      method: 'GET',
      types: ['OUTREACH_TYPES_REQUEST', 'OUTREACH_TYPES_SUCCESS', 'OUTREACH_TYPES_FAILURE',]
    }
  }
}

export function requestReferralCategories(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/referral-categories/all?${query}`,
      method: 'GET',
      types: ['REFERRAL_CATEGORIES_REQUEST', 'REFERRAL_CATEGORIES_SUCCESS', 'REFERRAL_CATEGORIES_FAILURE',]
    }
  }
}

export function requestReferralCategoriesByTypeId(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/lookups/referral-categories?${query}`,
      method: 'GET',
      types: ['CATEGORIES_REQUEST', 'CATEGORIES_SUCCESS', 'CATEGORIES_FAILURE',]
    }
  }
}

export function requestReferralsTypeahead(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/referrals/typeahead?${query}`,
      method: 'GET',
      types: ['REFERRALS_TYPEAHEAD_REQUEST', 'REFERRALS_TYPEAHEAD_SUCCESS', 'REFERRALS_TYPEAHEAD_FAILURE']
    }
  }
}

export function requestSearchReferralCategories(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/referral-category/search?${query}`,
      method: 'GET',
      types: ['REFERRALCATEGORY_REQUEST', 'REFERRALCATEGORY_SUCCESS', 'REFERRALCATEGORY_FAILURE']
    }
  };
}

export function requestReferralsByCategory(categoryId, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/referral-category/${categoryId}?${query}`,
      method: 'GET',
      types: ['REFERRALCATEGORY_DETAILS_REQUEST', 'REFERRALCATEGORY_DETAILS_SUCCESS', 'REFERRALCATEGORY_DETAILS_FAILURE']
    }
  }
}

export function deleteOutreach(id, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/outreach/${id}?${query}`,
      method: 'DELETE',
      body: JSON.stringify(id),
      types: ["OUTREACH_DELETE_REQUEST", "OUTREACH_DELETE_SUCCESS", "OUTREACH_DELETE_FAILURE"]
    }
  }
}

export function requestMakoRxPartners(params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/makorx/partners?${query}`,
      method: 'GET',
      types: ['MAKORX_PARTNERS_REQUEST', 'MAKORX_PARTNERS_SUCCESS', 'MAKORX_PARTNERS_FAILURE',]
    }
  }
}

export function updatePatientMakoRx(patientMakoRx, params) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/makorx/update?${query}`,
      method: 'PUT',
      body: JSON.stringify(patientMakoRx),
      types: ["PATIENT_MAKORX_UPDATE_REQUEST", "PATIENT_MAKORX_UPDATE_SUCCESS", "PATIENT_MAKORX_UPDATE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/outreach/OutreachActions.js